import { useMutation } from '@tanstack/react-query';

import { UseMutation } from 'services/api/types';

import { api_trackVisit } from './visits.queries';
import { ApiVisit } from './visits.types';

export const useTrackVisit: UseMutation<number, ApiVisit> = options =>
  useMutation(photoId => api_trackVisit(photoId), options);
